import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getEquipmentInventoriesAction, inventoriesSelector } from '../../../store/inventory'
import { Spin } from 'antd'
import { InventoriesTable } from '../InventoriesTable'

const EquipmentDetailView = ({ equipment, onRefresh }) => {
  const dispatch = useDispatch()
  const { equipmentInventories } = useSelector(inventoriesSelector)

  const [isFetching, setIsFetching] = useState(false)

  const loadData = async () => {
    try {
      setIsFetching(true)
      await dispatch(getEquipmentInventoriesAction(equipment))
    } catch (err) {
      console.error(err.error)
    } finally {
      setIsFetching(false)
    }
  }

  useEffect(() => loadData(), [equipment])

  const onRefreshAction = useCallback(() => {
    loadData()
    onRefresh()
  }, [equipment, onRefresh])

  const columns = [
    'id',
    'operation_type',
    'current_status',
    'created_date',
    'accept_date',
    'target',
    'create_user',
    'accept_user',
    'comment',
    'acceptance_act',
    'operations',
  ]

  return (
    <Spin spinning={isFetching}>
      <InventoriesTable
        columnNames={columns}
        dataSource={equipmentInventories[equipment]}
        onRefresh={onRefreshAction}
        isRowSelection={false}
      />
    </Spin>
  )
}

export default EquipmentDetailView
